export default {
  brand: 'USFansLink',
  nav: {
    home: 'Inicio',
    spreadsheet: 'Spreadsheet',
    categories: 'Categorías',
    guide: 'Guía',
    safety: 'Seguridad',
    shopGuide: 'Guía de compras',
  },
  hero: {
    eyebrow: 'El centro de recursos de USFans',
    title: 'USFans Spreadsheet — encuentra creadores, enlaces y recursos más rápido',
    subtitle:
      'Explora un recurso estructurado de USFans spreadsheet con enlaces de creadores, guías de búsqueda, comparaciones, actualizaciones e información de seguridad — todo en un solo lugar.',
    ctaPrimary: 'USFans Spreadsheet',
    ctaSecondary: 'Comprar ahora',
    searchPlaceholder: 'Busca creadores, enlaces, reseñas o recursos de USFans...',
    trust: 'Recursos organizados • Guías actualizadas • Información centrada en la seguridad',
  },
  category: {
    title: 'Explora por categoría',
    subtitle:
      'Compra las últimas colecciones de USFans — calzado, ropa, accesorios y más desde nuestra tienda principal.',
    dropdownLabel: 'Elige una categoría',
    dropdownPlaceholder: 'Selecciona una categoría para visitar...',
    viewCategory: 'Ver categoría',
  },
  categories: {
    shoes: 'Zapatos',
    hoodies: 'Sudaderas / Suéteres',
    tshirts: 'Camisetas',
    jackets: 'Chaquetas',
    pants: 'Pantalones / Pantalones cortos',
    headwear: 'Gorros y sombreros',
    sets: 'Conjuntos',
    underwear: 'Ropa interior / Calzoncillos',
    jersey: 'Camisetas deportivas',
    accessories: 'Accesorios',
    bags: 'Bolsos',
    belts: 'Cinturones',
    perfumes: 'Perfumes',
    other: 'Otras cosas',
  },
  valueProp: {
    title: 'Todo lo que necesitas para navegar por los recursos de USFans',
    cards: [
      { title: 'USFans Spreadsheet', text: 'Encuentra recursos y enlaces de creadores organizados.' },
      { title: 'Búsqueda de creadores', text: 'Descubre métodos prácticos de búsqueda e investigación.' },
      { title: 'Reseñas y guías', text: 'Explora reseñas, costos, cupones, legitimidad y tutoriales.' },
      { title: 'Centro de seguridad', text: 'Aprende a identificar enlaces sospechosos y proteger tu información.' },
    ],
  },
  core: {
    title: '¿Qué es el USFans Spreadsheet?',
    copy: 'El USFans Spreadsheet es un recurso estructurado diseñado para facilitar el descubrimiento de creadores y la investigación de enlaces de USFans. Explora información organizada, guías y recursos útiles desde un centro central.',
    tableHeaders: ['Creador', 'Categoría', 'Enlace', 'Estado', 'Actualizado'],
    tableRows: [
      ['Creador Uno', 'Zapatos', 'Ver', 'Activo', 'Esta semana'],
      ['Creador Dos', 'Sudaderas', 'Ver', 'Activo', 'Esta semana'],
      ['Creador Tres', 'Camisetas', 'Ver', 'Activo', 'El mes pasado'],
      ['Creador Cuatro', 'Camisetas deportivas', 'Ver', 'Activo', 'El mes pasado'],
      ['Creador Cinco', 'Accesorios', 'Ver', 'Activo', 'Este mes'],
    ],
    cta: 'Abrir USFans Spreadsheet',
  },
  intent: {
    title: 'Temas de búsqueda populares',
    subtitle: 'Respuestas rápidas a las preguntas que la gente más hace sobre USFans.',
    cards: [
      'Reseña de USFans',
      'Costo de envío de USFans',
      'Cupón de USFans',
      'Código de descuento de USFans',
      'Almacén de USFans',
      '¿USFans es legítimo?',
    ],
  },
  comparison: {
    title: 'Compara tus opciones',
    subtitle: 'Elige el enfoque que mejor se adapte a tu forma de navegar e investigar.',
    headers: ['Recurso', 'Ideal para', 'Organización', 'Facilidad de búsqueda'],
    rows: [
      ['USFans Spreadsheet', 'Investigación estructurada', 'Alta', 'Alta'],
      ['Directorio', 'Navegación', 'Media', 'Alta'],
      ['Búsqueda manual', 'Consultas rápidas', 'Baja', 'Media'],
    ],
  },
  safety: {
    title: 'Navega por los recursos de USFans con más seguridad',
    copy: 'Verifica los dominios, evita redirecciones sospechosas, nunca compartas contraseñas ni datos de pago, evita descargas desconocidas, ten cuidado con el phishing y respeta la privacidad de los creadores.',
    cta: 'Visitar el Centro de seguridad',
  },
  featuredGuide: {
    eyebrow: 'Guía destacada',
    title: 'USFans Spreadsheet: la guía completa',
    excerpt:
      'Aprende qué es el USFans Spreadsheet, cómo usarlo para encontrar creadores y enlaces, y cómo mantenerte seguro mientras navegas.',
    readMore: 'Leer la guía',
  },
  pillar: {
    eyebrow: 'Biblioteca de recursos USFans',
    title: 'Guías USFans',
    subtitle: 'Recursos detallados sobre búsqueda de creadores, enlaces, seguridad, reseñas y más.',
    readMore: 'Leer la guía',
    backHome: 'Volver al inicio',
  },
  finalCta: {
    title: '¿Listo para explorar los recursos del USFans Spreadsheet?',
    copy: 'Empieza con el USFans Spreadsheet y descubre guías útiles, comparaciones y recursos desde un centro organizado.',
    ctaPrimary: 'Explorar USFans Spreadsheet',
    ctaSecondary: 'Visitar el sitio principal',
  },
  footer: {
    tagline: 'USFansLink es un recurso informativo independiente. Los enlaces, la información y los servicios de terceros pueden cambiar con el tiempo.',
    disclaimer: 'Los usuarios deben verificar de forma independiente la información importante y seguir prácticas de seguridad en línea adecuadas.',
    navTitle: 'Explorar',
    navLinks: ['Inicio', 'Spreadsheet', 'Creadores', 'Guías', 'Seguridad'],
    legalTitle: 'Legal',
    legalLinks: ['Acerca de', 'Privacidad', 'Términos', 'Descargo', 'Contacto'],
    categoriesTitle: 'Categorías',
    copyright: 'Todos los derechos reservados.',
  },
};